import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { FC } from 'react'
import { EventReportManager } from '../../event-report/event-report-manager'

interface ContactButtonProps {
  href: string
  className?: string
  textClassName?: string
  label?: string
}

const ContactButton: FC<ContactButtonProps> = ({ href, className, textClassName, label }: ContactButtonProps) => {
  const rootNodeClass =
    'w-fit h-fit px-4 py-2 bg-gray-100 rounded-[19px] justify-center items-center gap-1 inline-flex cursor-pointer'
  const t = useTranslations()
  function fireContactEvent() {
    const event = { action: '', data: { event: 'initiate_lead' } }
    EventReportManager.getInstance().fireEventImmediately(event, true)
  }
  return (
    <Link href={href}>
      <div className={[rootNodeClass, className].join(' ')} onClick={fireContactEvent}>
        <div className={['text-black text-opacity-90 text-sm font-normal leading-snug', textClassName].join(' ')}>
          {label ?? t('ContactUs')}
        </div>
      </div>
    </Link>
  )
}

export default ContactButton
